import { render, staticRenderFns } from "./DialogCreateProject.vue?vue&type=template&id=4ecbcd62&scoped=true"
import script from "./DialogCreateProject.vue?vue&type=script&lang=js"
export * from "./DialogCreateProject.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateProject.vue?vue&type=style&index=0&id=4ecbcd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecbcd62",
  null
  
)

export default component.exports